export const MAX_LICENSE_EXPIRATION = 8640000000000000;

export const DEFAULT_RENEW_LICENSE_BEFORE_EXPIRATION = 300;